// src/components/Configurator/renderers/AirConditionerInternalRenderer.jsx
import React from "react";
import {
  SELECTED_ELEMENT_COLOR,
  defaultObjectSizes,
  OBJECT_TYPES,
} from "../configuratorConstants";
import { ReactComponent as AirConditionerInternalIcon } from "../../Assets/airin.svg";

const AirConditionerInternalRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor,
}) => {
  const defaults = defaultObjectSizes[OBJECT_TYPES.INTERNAL_AIR_CONDITIONER];
  const elementWidthM = element.width || defaults.width;
  const elementDepthM = element.depth || defaults.depth;

  const elementWidthPx = elementWidthM * scale;
  const elementDepthPx = elementDepthM * scale;
  const wallThicknessPx = wallThickness * scale;

  // ИЗМЕНЕНО: Сдвигаем блок так, чтобы его задняя часть была на поверхности стены
  const yOffset =
    placementSideFactor * (wallThicknessPx * 2 - elementDepthPx / 2);

  const iconStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "#fff",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "#4B5563",
    strokeWidth: isSelected ? 1.5 : 1,
  };

  // Масштабуємо зміщення по X
  const xOffset = 0.04 * scale; // 4см в метрах * scale

  const groupTransform = `translate(${xOffset}, ${yOffset}) rotate(-90) ${
    placementSideFactor === -1 ? "scale(1, -1)" : ""
  }`;

  const sizeMultiplier = 0.6;
  const visualWidth = elementDepthPx * sizeMultiplier;
  const visualHeight = elementWidthPx * sizeMultiplier;

  return (
    <g transform={groupTransform}>
      <AirConditionerInternalIcon
        x={-visualWidth / 2}
        y={-visualHeight / 2}
        width={visualWidth}
        height={visualHeight}
        preserveAspectRatio="xMidYMid meet"
        style={iconStyle}
      />
    </g>
  );
};

export default React.memo(AirConditionerInternalRenderer);